export default "__VITE_ASSET__DJ78Pd1S__"